// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `emergency/index${i + 1}`,
  name: `emergencyIndex${i + 1}`,
  component: () => import(`@/views/use/emergency/index${i + 1}.vue`)
}))



export default {
  path: '/use',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 紧急联系人——主流程，开始
    ...MainRoutes,

  ],
};
